import type { TimeField } from "shared/ui";

export interface DurationLimits {
  min_seconds: number;
  max_seconds: number;
}

// Пока meta не загрузилась — лимиты из ТЗ: от 1 минуты до 24 часов.
export const DEFAULT_DURATION_LIMITS: DurationLimits = {
  min_seconds: 60,
  max_seconds: 86400,
};

export const DEFAULT_DURATION_SEC = 3600;

export const DURATION_PRESETS = [300, 900, 1800, 3600];

const UNIT_SECONDS: Record<TimeField, number> = {
  hours: 3600,
  minutes: 60,
  seconds: 1,
};

// 60 / 86400 → "from 1 min to 24 h"
export const formatDurationLimits = ({
  min_seconds,
  max_seconds,
}: DurationLimits) => `from ${min_seconds / 60} min to ${max_seconds / 3600} h`;

export const clampToLimits = (total: number, limits: DurationLimits) =>
  Math.min(limits.max_seconds, Math.max(limits.min_seconds, total));

// ± к общей длительности: переполнение само уходит в старший разряд.
export const adjustDuration = (
  total: number,
  field: TimeField,
  delta: number,
  limits: DurationLimits,
): number => clampToLimits(total + delta * UNIT_SECONDS[field], limits);

export const splitDuration = (total: number) => ({
  hours: Math.floor(total / 3600),
  minutes: Math.floor((total % 3600) / 60),
  seconds: total % 60,
});
